/* =======================================================================
   Footer — Piè di pagina (logo + indirizzo + telefoni + Facebook + P.IVA)
   =======================================================================
   I dati mostrati arrivano da src/data/copy.js (sezioni "visit" e "footer").
   P.IVA e link Facebook sono "hardcoded" qui — cerca "01733590499" o
   "facebook.com" per modificarli.
   ======================================================================= */
import { useLang } from "@/context/LanguageContext";
import { asset } from "@/utils/asset";

export default function Footer({ copy }) {
  const { tr } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#2C2C2A] text-[#F7F4EB] py-20 lg:py-24"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-7">
            <div className="relative inline-block">
              <img
                src={asset("/assets/logo.jpg")}
                alt="Le Simpatiche Canaglie"
                data-testid="footer-logo"
                className="h-24 w-auto rounded-sm"
              />
              <sup className="absolute -top-1 -right-3 text-[0.75rem] text-[#E6C9A8] font-serif font-medium leading-none">
                ®
              </sup>
            </div>
            <p className="mt-6 font-serif italic text-xl text-[#EDE6D6]/85 max-w-lg">
              {tr(copy.footer.sign)}
            </p>
            <a
              data-testid="footer-facebook"
              href="https://www.facebook.com/lesimpatichecanaglierosignano"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 mt-6 text-[0.78rem] tracking-[0.22em] uppercase text-[#E6C9A8] hover:text-[#F7F4EB] transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M22 12.07C22 6.5 17.52 2 12 2S2 6.5 2 12.07c0 5.02 3.66 9.19 8.44 9.93v-7.02H7.9v-2.91h2.54V9.84c0-2.52 1.49-3.91 3.77-3.91 1.09 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.57v1.88h2.78l-.44 2.91h-2.34V22c4.78-.74 8.44-4.91 8.44-9.93z" />
              </svg>
              Facebook
            </a>
          </div>
          <div className="lg:col-span-5 grid sm:grid-cols-2 gap-8 text-sm font-light">
            <div>
              <p className="text-[0.7rem] tracking-[0.3em] uppercase text-[#E6C9A8] mb-3">
                {tr(copy.visit.address_label)}
              </p>
              <p className="whitespace-pre-line leading-relaxed">{tr(copy.visit.address)}</p>
            </div>
            <div>
              <p className="text-[0.7rem] tracking-[0.3em] uppercase text-[#E6C9A8] mb-3">
                {tr(copy.visit.contact_label)}
              </p>
              <ul className="space-y-1">
                {copy.visit.phones.map((p) => (
                  <li key={p.number}>
                    <a href={`tel:+39${p.number.replace(/\s/g, "")}`} className="hover:text-[#E6C9A8] transition-colors">
                      {p.number}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F7F4EB]/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-[0.72rem] tracking-[0.22em] uppercase text-[#EDE6D6]/70">
          <p data-testid="footer-piva">
            © {new Date().getFullYear()} Le Simpatiche Canaglie · P.IVA 01733590499
          </p>
          <p>{tr(copy.footer.rights)}</p>
        </div>
      </div>
    </footer>
  );
}
